<template>
    <v-data-table id="element-to-pdf" :headers="dMatCursosMinisterioEgresadoDetalleTable.headers" :items="dMatCursosMinisterioEgresadoDetalle" :loading="dMatCursosMinisterioEgresadoDetalleTable.loading" :search="dMatCursosMinisterioEgresadoDetalleTable.search" class="elevation-1 my-zebra-table portrait" style="max-width: 800px;" hide-default-footer :items-per-page="-1" dense max-width="400">
        <template v-slot:top>
            <div class="d-flex align-center pa-2">
                <v-spacer></v-spacer>
                <v-btn @click="fuPdf()" color="default" small>
                    <v-icon>picture_as_pdf</v-icon> PDF
                </v-btn>
            </div>
        </template>
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning" outlined border="top">No se encontro ningun registro con su busqueda "{{ dMatCursosMinisterioEgresadoDetalleTable.search }}".</v-alert></template>
        <template v-slot:[`item.Periodo`]="{ item }">
            <div class="text-center">
                <v-chip v-if="item.IdCursoCurricula" :color="fuColor12(item.Nivel)" text-color="white" small>{{ item.Periodo + ' ' + item.Nivel + item.Seccion }}</v-chip>
                <span v-else>
                    Nivel: {{item.Nivel}}
                </span>
            </div>
        </template>
        <template v-slot:[`item.EstadoAcademico`]="{ item }">
            <div class="text-center">
                <span v-if="item.IdCursoCurricula">APROBADO</span>
                <v-chip v-else color="error" text-color="white" small>DESAPROBADO</v-chip>
            </div>
        </template>
    </v-data-table>
</template>
<script>
import html2pdf from 'html2pdf.js';
import gql from 'graphql-tag';
import { fuColor12, fuTurnoIcono, fuMesNombreFecha} from '@/helpers/index.js';

export default {
    name: 'MatCursosMinisterioEgresado',
    props: {
        pIdAlumno: {
            default: null,
            type: Number
        },
    },
    mounted() {
        this.fumatcursosministerioEgresadoDetalle(this.pIdAlumno);
    },
    watch: {
        pIdAlumno(val){
            if(val){
                this.fumatcursosministerioEgresadoDetalle(parseInt(val));
            }
        },
    },
    data: () => ({
        dModal: {
            dialog: false,
            loading: false,
        },
        dIdSeccion: null,
        dMatSecciones: [],
        dCursoText: "",
        dMatCursosMinisterioEgresadoDetalle: [],
        dMatCursosMinisterioEgresadoDetalleDesaprobado: [],
        dMatCursosMinisterioEgresadoDetalleTable: {
            headers: [
                {value: 'Periodo', text: 'Periodo'},
                {value: 'Descripcion', text: 'Descripcion'},
                {value: 'NotaFinal', text: 'Nota Final'},                
                {value: 'EstadoAcademico', text: 'Estado'},
            ],
            loading: false,
            search: null,
            selected: []
        },
    }),
    methods: {
        fuColor12, fuTurnoIcono, fuMesNombreFecha,
        async fumatcursosministerioEgresadoDetalle(pIdAlumno) {
            this.dSeccionMax = { Periodo: '', Nivel: ''};
            this.dmatmatriculasByIdAlumno = [];
            this.dMatCursosMinisterioEgresadoDetalle = [];
            this.dMatCursosMinisterioEgresadoDetalleDesaprobado = [];
            this.dNiveles = [];
            this.dNivel = null;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdAlumno: ID!){
                            matcursosministerioEgresadoDetalle(IdAlumno: $IdAlumno){
                                IdCursoMinisterio
                                Descripcion
                                Nivel
                                Creditos
                                IdMatricula
                                IdSeccion
                                CondicionMat
                                IdCursoCurricula
                                NotaFinal
                                EstadoAcademico
                                Periodo
                                Seccion
                                Turno
                            }
                            matmatriculasByIdAlumno(IdAlumno: $IdAlumno){
                                IdMatricula
                                IdAlumno
                                IdSeccion
                                CondicionMat
                                Operador
                                matseccion{
                                    Seccion
                                    Turno
                                    FechaInicio
                                    FechaFin
                                    matperiodo{
                                        Anio
                                        Periodo
                                        Nivel
                                    }
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: pIdAlumno
                    }
                })
                const arrayIdCursoCurriculaNotNull = response.data.matcursosministerioEgresadoDetalle.filter(x=>x.IdCursoCurricula!=null);
                const arrayUniqueNivel = [...new Set(arrayIdCursoCurriculaNotNull.map(x => (x.Nivel)))];

                this.dMatCursosMinisterioEgresadoDetalle = response.data.matcursosministerioEgresadoDetalle.filter(x=>arrayUniqueNivel.includes(x.Nivel));
                this.dMatCursosMinisterioEgresadoDetalle = this.dMatCursosMinisterioEgresadoDetalle.sort((p1, p2) => (p1.Nivel < p2.Nivel) ? 1 : (p1.Nivel > p2.Nivel) ? -1 : 0);
                this.dMatCursosMinisterioEgresadoDetalleDesaprobado = this.dMatCursosMinisterioEgresadoDetalle.filter(x=>x.IdCursoCurricula == null);

                this.dNiveles = [...new Set(this.dMatCursosMinisterioEgresadoDetalleDesaprobado.map(x => (x.Nivel)))];

                this.dmatmatriculasByIdAlumno = response.data.matmatriculasByIdAlumno;
                this.dmatmatriculasByIdAlumno.sort((p1, p2) => (p1.IdMatricula < p2.IdMatricula) ? 1 : (p1.IdMatricula > p2.IdMatricula) ? -1 : 0);

                if(this.dmatmatriculasByIdAlumno.length>0){
                    this.dSeccionMax.Periodo = this.dmatmatriculasByIdAlumno[0].matseccion.matperiodo.Anio + '-'+ this.dmatmatriculasByIdAlumno[0].matseccion.matperiodo.Periodo;
                    this.dSeccionMax.Nivel = this.dmatmatriculasByIdAlumno[0].matseccion.matperiodo.Nivel;
                }
            } catch (error) {
                console.log(error);
            }
        },
        fuPdf(){
            var element = document.getElementById('element-to-pdf');
            var opt = {
                margin: 0,
                filename: 'NotaFinal_'+this.pIdAlumno+'.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 3 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                useCORS: true
            };
            html2pdf().from(element).set(opt).save();
        },
    }
}
</script>
<style scoped>
    .my-zebra-table >>> tbody tr:nth-of-type(even) {
        background-color: #f5f5f5; /* Un gris muy claro */
    }
    .my-zebra-table >>> tbody tr:hover {
        background-color: #eeeeee !important;
    }
    .portrait {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
    }
</style>
